import isMobile from "ismobilejs";
import Cookies from "js-cookie";
export const getDeviceModel = () => {
  if (typeof window !== "undefined") {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "Android";
      // @ts-ignore
    } else if (/iPad|iPhone|Mac|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
  }
  return "Unknown";
};

export const getDevicePlatform = () => {
  const isMobileDevice = isMobile(navigator.userAgent).any;
  return Cookies.get("webview") ? "app" : isMobileDevice ? "mweb" : "web";
};

export const isMobileDevice = (headersList: any) => {
  const userAgent: any = headersList.get('user-agent');
  return isMobile(userAgent).any
}
